import cx from 'classnames';
import type { ReactNode } from 'react';
import type { MessageType } from '..';
import { Icon } from '../../Icon';
import { CloseIconButton } from '../../IconButton';
import styles from './styles.module.css';

interface DismissButtonProps {
  onClick: () => void;
  type?: MessageType;
  // eslint-disable-next-line react/no-unused-prop-types
  white?: boolean;
}

export function LegacyDismissButton({ onClick, type, white }: DismissButtonProps): ReactNode {
  return (
    <button
      type="button"
      className={cx(styles.DismissButton, {
        [styles.Info]: !type,
        [styles.Confirmation]: type === 'success',
        [styles.Warning]: type === 'warning',
        [styles.Error]: type === 'danger',
      })}
      onClick={onClick}
    >
      <div className={cx(styles.Icon, { [styles.Light]: white })}>
        <Icon name="cross" />
      </div>
    </button>
  );
}

export function DismissButton({ onClick, type }: DismissButtonProps): ReactNode {
  const isWhite = false;

  return <CloseIconButton color={isWhite ? 'white' : undefined} onClick={onClick} />;
}
